import React from 'react';

import {TREND} from "../../app/consts";
import {BaseProps} from "../../../infrastructure/models/props/base-props";

export class HorizontalTrendProps extends BaseProps {
  trend: TREND;
  className: String;
}

export const HorizontalTrend = (props: HorizontalTrendProps) => {
  const containerProps = {
    className: [props.className, 'trend-container'].join(' ')
  }

  return (
    <div {...containerProps}>
      <div className={['horizontal-trend', `horizontal-trend-${props.trend}`].join(' ')}/>
    </div>
  )
}
